<template>
  <div class="order-page">
    <v-header>提交訂單</v-header>
    <div class="order-item">
      <div class="order-item_title">儲值角色</div>
      <div class="order-item_content">
        <span class="role-msg">{{userInfo.role_name}}</span>&nbsp;&nbsp;
        <span class="server-msg">{{userInfo.server_name}}</span>
      </div>
    </div>
    <div class="order-item">
      <div class="order-item_title">購買商品</div>
      <div class="order-item_content w_100 product-content">
        <div class="product-detail">
          <div class="product-left">
            <img class="product-icon" :src="productInfo.icon || defaultProduct" alt="product" />
          </div>
          <div class="product-right">
            <div class="product-name">{{productInfo.CP_PRODUCT_DESC || productInfo.PRODUCT_DESC}}</div>
            <div class="product-inner" v-if="productInfo.inner">{{productInfo.inner}}</div>
            <div class="product-cost_content">
              <div class="product-cost">
                價值：
                <span class="spec-color">
                  <span class>{{productInfo.COST_POINTS}}</span>G幣
                </span>
              </div>
              <div class="product-num">X{{productInfo.num}}</div>
            </div>
          </div>
        </div>
        <div class="product-more">
          <span class="product-left product-more_title">加碼贈送</span>
          <span class="product-right product-more_text">{{productExtract}}</span>
        </div>
      </div>
    </div>
    <div class="order-item">
      <div class="order-item_title">支付方式</div>
      <div class="order-item_content w_100">
        <div class="wallet-content">
          <div class="wallet-msg">
            <i class="wallet-icon"></i>
            <span class="wallet-name">G妹錢包</span>
          </div>
          <div class="wallet-select">
            您的餘額：
            <span class>{{userInfo.wallet}}</span>G幣
          </div>
        </div>
        <div class="wallet-tips">
          *現在
          <span class="wallet-tips_jump" @click="jumpToStore">儲值G妹錢包</span>立即獲得G幣抵用券
          <span class="wallet-tips_icon"></span>
          <span class="wallet-tips_more" @click="$router.push({name: 'wallet'})">G妹錢包</span>
        </div>
      </div>
    </div>
    <div class="order-item">
      <div class="order-item_title spec">
        <span class="coupon-title">抵用券</span>&nbsp;&nbsp;
        <span class="coupon-tips">每筆訂單限用一張抵用券</span>
      </div>
      <div class="order-item_content w_100 coupon-content" @click="showCouponPopup">
        <div class="coupon-msg">
          <i class="coupon-icon"></i>
          <span class="coupon-text">{{couponText}}</span>
        </div>
        <div class="coupon-select j-coupon-select-dcount" v-if="coupons.length">
          <span class="coupon-value j-coupon-select-dcount">{{coupons.length - 1}}張可用</span>
          <i class="icon-arrow_right j-coupon-select-dcount"></i>
        </div>
      </div>
    </div>
    <div class="order-bottom">
      <div class="less-tips" v-if="!walletEnough">
        <i class="tips-icon"></i>
        您的餘額不足，提交訂單將自動進入錢包充值頁面
      </div>
      <div class="order-bottom_main">
        <div class="bottom-left">
          <p class="bottom-left_price">
            實付：
            <span class="bottom-left_price--spec">
              <span class>{{costPrice}}</span>G幣
            </span>
          </p>
          <span class="bottom-left_origin">
            商品價格：
            <span class>{{productInfo.COST_POINTS}}</span>G幣
          </span>
        </div>
        <div class="bottom-right j-currency-submit-dcount" @click="confirmOrder">{{buttonText}}</div>
      </div>
    </div>
    <div class="password-input_mask" v-if="showPassword" @click="showPassword = false">
      <password
        @close="showPassword = false"
        @complete="handlePWDComplete"
        class="password-input_content"
      ></password>
    </div>
    <pl-tips
      v-if="showTips"
      :title="tipsTitle"
      class="order-tips"
      :show-close="false"
      @close="showTips=false"
      :class="[tipsTitle==='請完善您的賬號安全'?'pwd':false]"
    >
      <template v-if="tipsTitle === '密碼錯誤'" #body>
        <pre>{{errorMsg}}</pre>
        <div class="btn-group">
          <pl-gradient-btn
            type="plain"
            @click="handleClick"
            class="forget-btn j-forget-btn-dcount"
          >忘記密碼</pl-gradient-btn>
          <pl-gradient-btn class="retry-btn j-retry-btn-dcount" @click="reTry">重試</pl-gradient-btn>
        </div>
      </template>
      <template v-else #body>
        <span class="tips-content">{{tipsContent}}</span>
        <pl-gradient-btn class="j-set-pwd-dcount" @click="handleClick">立即設置</pl-gradient-btn>
      </template>
    </pl-tips>
    <popup-picker
      :list="coupons"
      title="抵用券列表"
      v-if="pickerShow"
      class="coupon-picker"
      @select="pickerSelect"
      @close="pickerShow = false"
    ></popup-picker>
  </div>
</template>

<script>
import qs from 'qs'
import { encryption } from '@/utils'
import plTips from '@/components/pl-tips'
import vHeader from '@/components/header'
import password from '@/components/password'
import defaultProduct from '@/assets/product.png'
import popupPicker from '@/components/popup-picker'
import plGradientBtn from '@/components/pl-gradient-btn'
export default {
  name: 'OrderPage',
  components: { vHeader, password, popupPicker, plTips, plGradientBtn },
  data () {
    return {
      defaultProduct,
      coupons: [],
      curCoupon: {},
      productInfo: {},
      info: {},
      pickerShow: false,
      showPassword: false,
      params: {},
      showTips: false,
      errorMsg: '',
      tipsTitle: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.getUserInfo
    },
    buttonText () {
      return '提交訂單'
    },
    couponText () {
      if (!this.coupons.length) {
        return '暫無可用抵用券'
      } else {
        return this.curCoupon.name || '請選擇抵用券'
      }
    },
    costPrice () {
      let productPrice = +this.productInfo.COST_POINTS || 0
      let couponPrice = this.curCoupon.value || 0
      let value = productPrice - couponPrice
      return value <= 0 ? 0 : value
    },
    walletEnough () {
      return this.userInfo.wallet - this.costPrice >= 0
    },
    productExtract () {
      if (this.productInfo.EXTRA_COIN) {
        return this.productInfo.EXTRA_COIN + this.info.coin_name
      } else {
        return '無'
      }
    }
  },
  methods: {
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    reTry () {
      this.tipsTitle = ''
      this.errorMsg = ''
      this.showTips = false
      this.showPassword = true
    },
    handlePWDComplete (pwd) {
      let couponId = +this.curCoupon.id === -1 ? '' : this.curCoupon.id
      let params = {
        flowType: -1,
        paytype: 'points_pay',
        coupons: couponId,
        payPassword: encryption(pwd),
        currency: 'TWD',
        ...this.params
      }
      this.$store.commit('setLoadingState', true)
      this.$http
        .post('//mstore.gm99.com/points_pay/submit', qs.stringify(params), {
          withCredentials: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(res => {
          res = res.data
          this.showPassword = false
          this.$store.commit('setLoadingState', false)
          if (res.data.sub_err_code === 'PW') {
            this.tipsTitle = '密碼錯誤'
            this.showTips = true
            this.errorMsg = res.msg
          } else {
            window.sessionStorage.setItem(
              'order-params',
              JSON.stringify(this.$route.query)
            )
            this.$router.push({
              name: 'result',
              query: {
                result: res.result,
                purchase: 1,
                game: this.userInfo.game_name,
                serverName: this.userInfo.server_name,
                roleName: this.userInfo.role_name,
                product:
                  this.productInfo.CP_PRODUCT_DESC ||
                  this.productInfo.PRODUCT_DESC,
                price: this.costPrice,
                oldPrice: this.productInfo.COST_POINTS,
                couponPrice: this.curCoupon.value,
                msg: res.msg,
                ano: res.data.order_id
              }
            })
          }
        })
        .catch(err => {
          this.$store.commit('setLoadingState', false)
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    confirmOrder () {
      if (this.walletEnough) {
        this.confirmPassword()
      } else {
        this.$router.push({ name: 'store' })
      }
    },
    jumpToStore () {
      this.$router.push({ name: 'store' })
    },
    showCouponPopup () {
      if (this.coupons.length) {
        this.pickerShow = true
      }
    },
    pickerSelect (data) {
      this.curCoupon = data
    },
    fetchBasicInfo (params) {
      params = { ...params, serverId: this.userInfo.server_sid }
      this.$jsonp('//mstore.gm99.com/points/payment_data', params)
        .then(res => {
          let data = res.data
          if (+res.result === 1) {
            let product = JSON.parse(this.$route.query.product)
            this.productInfo = Object.assign({}, product, {
              num: 1,
              // inner: '時間加速器*1',
              icon: this.$route.query.icon
            })
            this.info = data
            this.initCoupons(data.coupons)
            this.$store.commit('setLoadingState', false)
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    initCoupons (data) {
      let formatTimeText = str => {
        if (str.startsWith('9999')) {
          return '無限期'
        }
        let index = str.indexOf(' ')
        return str.substr(0, index).replace(/-/gi, '.')
      }
      let coupons = data.map(item => {
        item.id = item.ID
        item.name = `${item.REDUCTION}G幣抵用券`
        item.value = +item.REDUCTION
        let time = formatTimeText(item.EXPIRY_TIME)
        item.more = `${time === '無限期' ? time : `有效期至${time}`}`
        return item
      })
      if (data.length) {
        this.curCoupon = coupons[0]
        coupons.unshift({ id: -1, value: 0, name: '不使用抵用券' })
      }
      this.coupons = coupons
    },
    handleClick () {
      this.$jsonp('//passport.gm99.com/ajax/user_info')
        .then(res => {
          let data = res.data
          if (+res.result === 1) {
            let isBind = data.PHONE !== '' || data.EMAIL !== ''
            let authType = data.PHONE ? 'mobile' : data.EMAIL ? 'email' : ''
            let contact = authType === 'mobile' ? data.PHONE : data.EMAIL
            this.$router.push({
              name: 'passwordSetting',
              query: {
                isBind: +isBind,
                authType,
                contact,
                from: 'order',
                old: JSON.stringify(this.$route.query)
              }
            })
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    showMessage (status) {
      status = parseInt(status, 10)
      if (status === 1) {
        this.showPassword = true
      }
      if (status < 0) {
        this.showTips = true
        this.tipsTitle = '請完善您的賬號安全'
        if (status === -1) {
          this.tipsContent =
            '您尚未設置二級密碼，為了保護您的賬號安全，請您務必設置二級密碼。'
        } else if (status === -2) {
          this.tipsContent =
            '系統升級，為了給玩家提供更便捷的支付體驗，需要您重新設置6位數字的二級密碼來代替您原有的二級密碼。'
        }
      }
    },
    confirmPassword () {
      if (this.btnText === '去儲值') {
        window.location.href =
          process.env.NODE_ENV === 'development'
            ? `//zero.gm99.com:8080/${window.location.search}#/store`
            : `//mstore.gm99.com/points/${window.location.search}#/store`
        return
      }
      // 獲取用戶密碼狀態，舊二級密碼，未設置密碼
      this.$jsonp('//passport.gm99.com/center/secondary_password/status')
        .then(res => {
          let data = res.data
          if (+res.result === 1) {
            this.showMessage(data.STATUS)
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    }
  },
  created () {
    if (!this.userInfo.role_id) {
      this.$router.replace({ name: 'game' })
      return
    }
    this.params = {
      gameId: this.userInfo.game_id,
      serverId: this.userInfo.server_id,
      roleId: this.userInfo.role_id,
      roleName: this.userInfo.role_name,
      userId: this.userInfo.UID,
      productId: this.$route.query.pId,
      cpProductId: this.$route.query.cpId,
      currency: this.$route.query.currency,
      devicePlate: 'pc'
    }
    this.fetchBasicInfo(this.params)
  }
}
</script>

<style lang="scss" scoped>
.w_100 {
  width: 100% !important;
}
.order-page {
  overflow: auto;
  text-align: left;
  min-height: 100%;
  padding-bottom: 85px;
  box-sizing: border-box;
  background-color: #f4f4f4;
  .order-item {
    padding: 17px;
    margin-top: 10px;
    background: #fff;
    box-sizing: border-box;
    &_title {
      width: 60px;
      font-size: 13px;
      color: #6d6d6d;
      display: inline-block;
      &.spec {
        width: 100%;
        font-size: 0;
      }
      .coupon-title {
        font-size: 13px;
      }
      .coupon-tips {
        font-size: 11px;
        text-align: right;
        display: inline-block;
        width: calc(100% - 40px);
      }
    }
    &_content {
      text-align: right;
      display: inline-block;
      width: calc(100% - 60px);
    }
  }
  .role-msg {
    color: #333;
    font-size: 15px;
  }
  .server-msg {
    font-size: 13px;
    color: #6d6d6d;
  }
  .product-content {
    text-align: left;
    .product-detail {
      display: flex;
      padding: 13px 0;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      border-bottom: 1px solid #ebebeb;
      .product-left {
        font-size: 0;
      }
      .product-icon {
        width: 70px;
        height: 70px;
      }
      .product-name {
        color: #333;
        font-size: 15px;
        font-weight: 700;
      }
      .product-inner {
        font-size: 11px;
        color: #9c9c9c;
      }
      .product-cost_content {
        display: flex;
        overflow: hidden\9;
        align-items: center;
        justify-content: space-between;
      }
      .product-cost {
        float: left\9;
        font-size: 11px;
        color: #6d6d6d;
        .spec-color {
          font-size: 18px;
          color: #e97d30;
        }
      }
      .product-num {
        float: right\9;
        font-size: 12px;
        color: #9c9c9c;
      }
    }
    .product-more {
      margin-top: 18px;
      &_title {
        font-size: 13px;
        color: #6d6d6d;
      }
      &_text {
        color: #333;
        font-size: 13px;
        font-weight: 700;
      }
    }
    .product-left {
      width: 100px;
      display: inline-block;
      vertical-align: middle;
    }
    .product-right {
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 100px);
    }
  }
  .wallet-content {
    display: flex;
    color: #333;
    overflow: hidden\9;
    font-size: 13px;
    margin-top: 17px;
    font-weight: 700;
    align-items: center;
    padding-bottom: 14px;
    justify-content: space-between;
    border-bottom: 1px solid #ebebeb;
    .wallet-msg {
      float: left\9;
    }
    .wallet-select {
      float: right\9;
    }
    .wallet-icon {
      width: 16px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
      background-size: 100% 100%;
      background-image: url(../assets/wallet.png);
    }
    .wallet-name {
      padding-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .wallet-tips {
    font-size: 11px;
    text-align: left;
    margin-top: 14px;
    color: #6d6d6d;
    &_jump {
      cursor: pointer;
      font-weight: 700;
      padding-right: 3px;
      text-decoration: underline;
    }
    &_icon {
      width: 9px;
      height: 9px;
      margin: 0 5px;
      display: inline-block;
      background-size: 100% 100%;
      background-image: url(../assets/question.png);
    }
    &_more {
      color: #9c9c9c;
    }
  }
  .coupon-content {
    display: flex;
    color: #333;
    font-size: 13px;
    margin-top: 17px;
    font-weight: 700;
    overflow: hidden\9;
    align-items: center;
    justify-content: space-between;
    .coupon-msg {
      float: left\9;
    }
    .coupon-select {
      float: right\9;
    }
    .coupon-icon {
      width: 16px;
      height: 13px;
      display: inline-block;
      background-size: 100% 100%;
      vertical-align: text-bottom;
      background-image: url(../assets/coupon.png);
    }
    .coupon-text {
      padding-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
    .coupon-value {
      padding-right: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .order-bottom {
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 50px;
    position: fixed;
    .less-tips {
      height: 35px;
      padding: 0 15px;
      font-size: 10px;
      color: #e97d30;
      line-height: 40px;
      box-sizing: border-box;
      background-color: #faf8d9;
      .tips-icon {
        width: 10px;
        height: 10px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: text-top;
        background-size: 100% 100%;
        background-image: url(../assets/warning.png);
      }
    }
    &_main {
      display: flex;
      text-align: left;
      background: #fff;
      align-items: center;
      align-content: center;
      justify-content: space-between;
      .bottom-left {
        flex: 1;
        height: 50px;
        width: calc(100% - 122px) \9;
        display: inline-block\9;
        padding: 10px 17px 0;
        box-sizing: border-box;
        &_price {
          margin: 0;
          padding: 0;
          line-height: 1;
          font-size: 15px;
          color: #6d6d6d;
          &--spec {
            color: #e97d30;
          }
        }
        &_origin {
          font-size: 10px;
          color: #9c9c9c;
          text-decoration: line-through;
        }
      }
      .bottom-right {
        height: 50px;
        color: #fff;
        flex: 0 0 122px;
        width: 122px\9;
        display: inline-block\9;
        line-height: 50px;
        text-align: center;
        background: #e97d30;
      }
    }
  }
  .order-tips {
    & /deep/ .pl-tips_main {
      padding: 0 10px;
      flex-direction: column;
    }
    &.pwd /deep/ .pl-tips_main {
      justify-content: space-around;
    }
    pre {
      font-size: 15px;
      text-align: center;
      margin-bottom: 40px;
      font-family: initial;
    }
    .btn-group {
      width: 100%;
      display: flex;
      overflow: hidden\9;
      align-items: center;
      justify-content: space-around;
      .retry-btn {
        float: left\9;
      }
      .forget-btn {
        float: right\9;
      }
    }
    & /deep/ .pl-gradient-btn {
      width: 100px;
    }
  }
  .password-input {
    &_mask {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: fixed;
      background-color: rgba(0, 0, 0, 0.8);
    }
    &_content {
      margin: 5% auto;
    }
  }
  .coupon-picker /deep/ .more {
    font-size: 12px;
  }
}
@media screen and (orientation: landscape) {
  .order-page {
    height: auto;
    .order-item:nth-of-type(5) {
      margin-bottom: 60px;
    }
  }
}
</style>
